module.exports = __webpack_public_path__ + "img/img_clients10.de7b614c.jpg";